module.exports = __webpack_public_path__ + "files/725b5e2f8b7e0bfac66edad5c2291b86.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Ubuntu-regular.ttf
// module id = 790
// module chunks = 60